const setupContinueWithEmail = (formId) => {
  const formContainer = document.getElementById(formId);

  if (!formContainer) {
    return;
  }

  const continueWithEmail = document.getElementById('continue-with-email');

  if (!continueWithEmail) {
    formContainer.style.visibility = 'visible';
    formContainer.style.maxHeight = 'max-content';
    return;
  }

  const continueWithEmailChevron = continueWithEmail.querySelector('.continue-with-email-chevron');

  continueWithEmail.addEventListener('click', () => {
    const isCollapsed = formContainer.style.maxHeight === '0px';
    formContainer.style.maxHeight = isCollapsed ? 'max-content' : '0px';
    formContainer.style.visibility = isCollapsed ? 'visible' : 'hidden';
    continueWithEmailChevron.classList.remove('rotate-180');
    if (isCollapsed) {
      continueWithEmailChevron.classList.add('rotate-180');
    }
  });

  // Automatically expand the form if the email is present
  const expandEmailInput = formContainer.querySelector('#expand_email_form');
  if (expandEmailInput && expandEmailInput.value === true) {
    continueWithEmail.click();
  }

  continueWithEmail.removeAttribute('aria-disabled');
};

export { setupContinueWithEmail };
